/**
 * What pressing Save on the labour group card should do.
 *
 * "None" is a real choice, not a no-op: picking it against an assigned group
 * removes the assignment. Null and undefined both mean "no group", so a user
 * who never had one and picks None again is left alone.
 */
export type LabourGroupSaveIntent =
  | { action: 'assign'; groupId: number }
  | { action: 'remove' }
  | { action: 'none' };

export const resolveLabourGroupSaveIntent = (
  selectedGroupId: number | null,
  currentGroupId: number | null | undefined
): LabourGroupSaveIntent => {
  const current = currentGroupId ?? null;

  if (selectedGroupId === current) {
    return { action: 'none' };
  }

  if (selectedGroupId === null) {
    return { action: 'remove' };
  }

  return { action: 'assign', groupId: selectedGroupId };
};
